import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Login'

import { verificaSeEstaLogado1 } from './utils/util'


//Adm Master
import BaseMaster from '@/views/adm_master/Base'

import DashboardMaster from '@/views/adm_master/dashboard/Home'

import ListaUniodontosMaster from '@/views/adm_master/uniodontos/Uniodontos'
import CriaUniodontosMaster from '@/views/adm_master/uniodontos/Cria_Uniodonto'
import EditaUniodontosMaster from '@/views/adm_master/uniodontos/Detalhe_Uniodonto'

import ListaUsuariosMaster from '@/views/adm_master/usuarios/Usuarios'
import CriaUsuariosMaster from '@/views/adm_master/usuarios/Cria_Usuario'
import EditaUsuariosMaster from '@/views/adm_master/usuarios/Detalhe_Usuario'

import ListaPlanosMaster from '@/views/adm_master/planos/Planos'
import CriaPlanosMaster from '@/views/adm_master/planos/Cria_Plano'
import EditaPlanosMaster from '@/views/adm_master/planos/Detalhe_Plano'

import ListaCuponsMaster from '@/views/adm_master/cupons/Cupons.vue'
import CriaCumponsMaster from '@/views/adm_master/cupons/Cria_Cupom'
import EditaCuponsMaster from '@/views/adm_master/cupons/Detalhe_Cupom'

import ListaAssinantesMaster from '@/views/adm_master/assinantes/Assinantes'
import CriaAssinantesMaster from '@/views/adm_master/assinantes/Cria_Assinante'
import EditaAssinantesMaster from '@/views/adm_master/assinantes/Detalhe_Assinante'
import CopiaAssinatura from '@/views/adm_master/assinantes/Copia_Assinatura'

import ListaLeadsMaster from '@/views/adm_master/leads/Leads'

import ListaTitularesMaster from '@/views/adm_master/titulares/Titulares'
import CriaTitularesMaster from '@/views/adm_master/titulares/Cria_Titular'
import EditaTitularesMaster from '@/views/adm_master/titulares/Detalhe_Titular' 

import ListaDependentesMaster from '@/views/adm_master/dependentes/Dependentes'
import CriaDependentesMaster from '@/views/adm_master/dependentes/Cria_Dependente'
import EditaDependentesMaster from '@/views/adm_master/dependentes/Detalhe_Dependente' 

import ListaCarrinhoMaster from '@/views/adm_master/carrinho/Carrinho'
import EditaCarrinhoMaster from '@/views/adm_master/assinantes/Detalhe_Assinante'

import EventosMaster from '@/views/adm_master/eventos/Eventos'
import DetalhesEventosMaster from '@/views/adm_master/eventos/Detalhes_Eventos'

import Empresas from './views/adm_master/empresas/Empresas.vue'
import Cria_Empresas from './views/adm_master/empresas/Cria_Empresas.vue'
import Detalhe_Empresas from './views/adm_master/empresas/Detalhe_Empresas.vue'


import MarketingMaster from '@/views/adm_master/marketing/MarketingMaster';


//Adm Uniodonto
import BaseUniodonto from '@/views/adm_uniodonto/Base'

import DashboardUniodonto from '@/views/adm_uniodonto/dashboard/Home'

import InformacoesUniodonto from '@/views/adm_uniodonto/informacoes/Index'

import ListaPlanosUniodonto from '@/views/adm_uniodonto/planos/Planos'
import CriaPlanosUniodonto from '@/views/adm_uniodonto/planos/Cria_Plano'
import EditaPlanosUniodonto from '@/views/adm_uniodonto/planos/Detalhe_Plano'

import ListaCorretoresUniodonto from '@/views/adm_uniodonto/corretores/Corretores'
import CriaCorretoresUniodonto from '@/views/adm_uniodonto/corretores/Cria_Corretor'
import EditaCorretoresUniodonto from '@/views/adm_uniodonto/corretores/Detalhe_Corretor'

import ListaAssinantesUniodonto from '@/views/adm_uniodonto/assinantes/Assinantes'
import EditaAssinantesUniodonto from '@/views/adm_uniodonto/assinantes/Detalhe_Assinante'

import ListaCuponsUniodonto  from '@/views/adm_uniodonto/cupons/Cupons.vue'
import CriaCumponsUniodonto  from '@/views/adm_uniodonto/cupons/Cria_Cupom.vue'
import EditaCuponsUniodonto  from '@/views/adm_uniodonto/cupons/Detalhe_Cupom.vue'

import RelatoriosUniodonto from '@/views/adm_uniodonto/relatorios/Relatorios';

import MarketingUniodonto from '@/views/adm_uniodonto/marketing/MarketingUniodonto';

import Cria_EmpresasUni from './views/adm_uniodonto/empresas/Cria_EmpresasUni.vue'
import Detalhe_EmpresasUni from './views/adm_uniodonto/empresas/Detalhe_EmpresasUni.vue'
import EmpresasUni from './views/adm_uniodonto/empresas/EmpresasUni.vue'

import ListaOportunidadesUniodonto from '@/views/adm_uniodonto/oportunidades/index'
import DetalheOportunidadeUniodonto from '@/views/adm_uniodonto/oportunidades/detalhes'

//Adm Corretor
import BaseCorretor from '@/views/adm_corretor/Base'
import DashboardCorretor from '@/views/adm_corretor/dashboard/Home'
import DetalheOportunidade from '@/views/adm_corretor/oportunidades/detalhes'
import Oportunidades from '@/views/adm_corretor/oportunidades/index'

import DetalheVenda from '@/views/adm_corretor/vendas/detalhes'
import Vendas from '@/views/adm_corretor/vendas/index'



import NotFound from '@/views/NotFound'


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (Router.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (Router.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    //Rotas do ADM MASTER
    {
      path: '/adm/',
      name: 'AdmMaster',
      component: BaseMaster,
      children:
      [
        //Dashboard
        {
          path: 'dashboard',

          name: 'DashboardMaster',
          component: DashboardMaster
        },
        //Empresas
        {
          path:'empresas',
          name:"Empresas",
          component:Empresas
        },
        {
          path:'empresas/cria-empresa',
          name:"CriaEmpresas",
          component:Cria_Empresas
        },
        {
          path:'empresas/:id_empresa',
          name:"DetalhesEmpresas",
          component:Detalhe_Empresas
        },
        //Uniodonto
        {
          path: 'uniodontos',
          name: 'ListaUniodontosMaster',
          component: ListaUniodontosMaster
        },
        {
          path: 'uniodontos/criar-uniodonto',
          name: 'CriaUniodontosMaster',
          component: CriaUniodontosMaster
        },
        {
          path: 'uniodontos/:id_uniodonto',
          name: 'EditaUniodontosMaster',
          component: EditaUniodontosMaster
        },
        //Usuarios
        {
          path: 'usuarios',
          name: 'ListaUsuariosMaster',
          component: ListaUsuariosMaster
        },
        {
          path: 'usuarios/criar-usuario',
          name: 'CriaUsuariosMaster',
          component: CriaUsuariosMaster
        },
        {
          path: 'usuarios/:id_usuario',
          name: 'EditaUsuariosMaster',
          component: EditaUsuariosMaster
        },
        //Planos
        {
          path: 'planos',
          name: 'ListaPlanosMaster',
          component: ListaPlanosMaster
        },
        {
          path: 'planos/criar-plano',
          name: 'CriaPlanosMaster',
          component: CriaPlanosMaster
        },
        {
          path: 'planos/:id_plano',
          name: 'EditaPlanosMaster',
          component: EditaPlanosMaster
        },

        {
          path: 'cupons',
          name: 'ListaCupons',
          component: ListaCuponsMaster
        },
        {
          path: 'cupons/criar-cupom',
          name: 'CriaCumponsMaster',
          component: CriaCumponsMaster
        },
        {
          path: 'cupons/:id_cupom',
          name: 'EditaCuponsMaster',
          component: EditaCuponsMaster
        },


        //Assinantes
        {
          path: 'assinantes',
          name: 'ListaAssinantesMaster',
          component: ListaAssinantesMaster
        },
        {
          path: 'assinantes/criar-assinante',
          name: 'CriaAssinantesMaster',
          component: CriaAssinantesMaster
        },
        {
          path: 'assinantes/:protocolo',
          name: 'EditaAssinantesMaster',
          component: EditaAssinantesMaster
        },
        {
          path: 'assinantes/copia_assinatura/:id',
          name: 'Copia_Assinatura',
          component: CopiaAssinatura
        },
        //Titulares
        {
          path: 'titulares',
          name: 'ListaTitularesMaster',
          component: ListaTitularesMaster,
        },
        {
          path: 'titulares/criar-titular',
          name: 'CriaTitularesMaster',
          component: CriaTitularesMaster
        },
        {
          path: 'titulares/:id_titular',
          name: 'EditaTitularMaster',
          component: EditaTitularesMaster
        },
        //Dependentes
        {
          path: 'dependentes',
          name: 'ListaDependentesMaster',
          component: ListaDependentesMaster,
        },
        {
          path: 'dependentes/criar-dependente',
          name: 'CriaDependentesMaster',
          component: CriaDependentesMaster
        },
        {
          path: 'dependentes/:id_dependente',
          name: 'EditaDependentesMaster',
          component: EditaDependentesMaster
        },
        //Carrinho
        {
          path: 'carrinho',
          name: 'ListaCarrinhoMaster',
          component: ListaCarrinhoMaster
        },
        {
          path: 'marketing/:id',
          name: 'MarketingMaster',
          component: MarketingMaster
        },
        {
          path: 'carrinho/:id_carrinho',
          name: 'EditaAssinantesMaster',
          component: EditaAssinantesMaster
        },

        //Leads
        {
          path: 'leads',
          name: 'ListaLeads',
          component: ListaLeadsMaster
        },

        //Eventos
        {
          path: 'eventos',
          name: 'Eventos',
          component: EventosMaster
        },
        {
          path: 'detalhes-eventos/:id',
          name: 'Detalhes-Eventos',
          component: DetalhesEventosMaster
        },

        {
          path: '/404',
          name: 'NotFound',
          component: NotFound
        },

        {
          path: '(.*)',
          component: NotFound,
        },
      ],
    },
    //Rotas das uniodontos
    {
      path: '/uniodonto/',
      name: 'AdmUniodonto',
      component: BaseUniodonto,
      children:
      [
        //Dashboard
        {
          path: 'dashboard',
          name: 'DashboardUniodonto',
          component: DashboardUniodonto
        },
        //Empresas
        {
          path:'empresas',
          name:"Empresas",
          component:EmpresasUni
        },
        {
          path:'empresas/cria-empresa',
          name:"CriaEmpresas",
          component:Cria_EmpresasUni
        },
        {
          path:'empresas/:id_empresa',
          name:"DetalhesEmpresas",
          component:Detalhe_EmpresasUni
        },
        //Informações
        {
          path: 'informacoes',
          name: 'InformacoesUniodonto',
          component: InformacoesUniodonto
        },
        //Planos
        {
          path: 'planos',
          name: 'ListaPlanosUniodonto',
          component: ListaPlanosUniodonto
        },
        {
          path: 'planos/criar-plano',
          name: 'CriaPlanosUniodonto',
          component: CriaPlanosUniodonto
        },
        {
          path: 'planos/:id_plano',
          name: 'EditaPlanosUniodonto',
          component: EditaPlanosUniodonto
        },
        //Corretores
        {
          path: 'corretores',
          name: 'ListaCorretoresUniodonto',
          component: ListaCorretoresUniodonto
        },
        {
          path: 'corretores/criar-corretor',
          name: 'CriaCorretoresUniodonto',
          component: CriaCorretoresUniodonto
        },
        {
          path: 'corretores/:id_corretor',
          name: 'EditaCorretoresUniodonto',
          component: EditaCorretoresUniodonto
        },
        //Cuponds
        {
          path: 'cupons',
          name: 'ListaCuponsUniodonto',
          component: ListaCuponsUniodonto
        },
        {
          path: 'cupons/criar-cupom',
          name: 'CriaCumponsUniodonto',
          component: CriaCumponsUniodonto
        },
        {
          path: 'cupons/:id_cupom',
          name: 'EditaCuponsUniodonto',
          component: EditaCuponsUniodonto
        },
        //Assinantes
        {
          path: 'assinantes',
          name: 'ListaAssinantesUniodonto',
          component: ListaAssinantesUniodonto
        },
        {
          path: 'assinantes/:protocolo',
          name: 'EditaAssinantesUniodonto',
          component: EditaAssinantesUniodonto
        },
        //Oportunidades
        {
          path: 'oportunidades',
          name: 'ListaOportunidadesUniodonto',
          component: ListaOportunidadesUniodonto
        },
        {
          path: 'oportunidades/detalhes/:id',
          name: 'DetalheOportunidadeUniodonto',
          component: DetalheOportunidadeUniodonto
        },
        {
          path: 'relatorios',
          name: 'RelatoriosUniodonto',
          component: RelatoriosUniodonto
        },
        //Marketing
        {
          path: 'marketing',
          name: 'MarketingUniodonto',
          component: MarketingUniodonto
        },
        //Cópia de assinatura
        {
          path: 'assinantes/copia_assinatura/:id',
          name: 'Copia_AssinaturaUniodonto',
          component: CopiaAssinatura
        },
        //Não encontrados
        {
          path: '/404',
          name: 'NotFound',
          component: NotFound
        },
        {
          path: '(.*)',
          component: NotFound,
        }
      ],
    },

    {
      path: '/corretor/',
      name: 'AdmCorretor',
      component: BaseCorretor,
      children:
      [
        //Dashboard
        {
          path: 'dashboard',
          name: 'DashboardCorretor',
          component: DashboardCorretor
        },
        {
          path: 'oportunidades/detalhes/:id?',
          name: 'DetalheOportunidade',
          component: DetalheOportunidade
        },
        {
          path: 'oportunidades',
          name: 'Oportunidades',
          component: Oportunidades
        },
        {
          path: 'vendas/detalhes/:id?',
          name: 'DetalheVenda',
          component: DetalheVenda
        },
        {
          path: 'vendas',
          name: 'Vendas',
          component: Vendas
        },
      ]
    }
    ]
  })
  
export default router

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    return next()
  }

  const userRole = localStorage.getItem('adm_comprodonto_role')
  console.log('userRole', userRole)
  const routePermissions = [
    { prefix: '/adm/', role: 3 },
    { prefix: '/uniodonto/', role: 2 },
    { prefix: '/corretor/', role: 4 }
  ]

  for (const config of routePermissions) {
    if (to.path.startsWith(config.prefix)) {
      if (!userRole || userRole != config.role) {
        console.log('userRole diferente', userRole, config.role)

        if (userRole === '3') {
          const equivalentPath = to.path.replace(config.prefix, '/adm/')
          return next(equivalentPath)
        } else if (userRole === '2') {
          const equivalentPath = to.path.replace(config.prefix, '/uniodonto/')
          return next(equivalentPath)
        } else if (userRole === '4') {
          const equivalentPath = to.path.replace(config.prefix, '/corretor/')
          return next(equivalentPath)
        } else {
          /* localStorage.removeItem('token_adm_comprodonto') */
          return next('/')
        }
      }
    }
  }

  next()
})